// Display-only: OLG's MSP ministry names encode the slot number and
// Mass time ("Usher - 5:Sunday 5:30pm") — the slot is scheduling
// detail and the time repeats the card's mass line. Show just the
// role; the payload keeps the full string. Names without " - "
// ("Hospitality Minister", "Sacristan") pass through untouched.
export function roleLabel(ministry: string): string {
  const dash = ministry.indexOf(" - ");
  return dash === -1 ? ministry : ministry.slice(0, dash).trim();
}

// OLG's per-slot ministry records ("Usher - 3:Sunday 9am", "Usher -
// 4:Sunday 11:30am") collapse to the same roleLabel — a volunteer
// qualified for several slots would otherwise show the same badge
// repeated. Cleans + dedupes, preserving first-seen order.
export function dedupeRoles(ministries: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const m of ministries) {
    const label = roleLabel(m);
    if (seen.has(label)) continue;
    seen.add(label);
    out.push(label);
  }
  return out;
}
